import { c as _c } from "react/compiler-runtime";
import BlurFade from "@/components/magicui/blur-fade";
import { Badge } from "@/components/ui/badge";
import { GeneralProps } from "@/types/types";
import { cn } from "@/utils/helpers";
export function SectionWrapper(t0) {
  const $ = _c(6);
  const {
    sectionId,
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("mx-auto mt-8 max-w-7xl px-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== sectionId || $[4] !== t1) {
    t2 = <section className={t1} id={sectionId}>{children}</section>;
    $[2] = children;
    $[3] = sectionId;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function SectionContent(t0) {
  const $ = _c(8);
  const {
    animate: t1,
    className,
    children
  } = t0;
  const animate = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("rounded-xl border-t bg-gradient-to-b from-background via-background to-transparent py-8 md:border md:px-6 md:dark:border-0 md:dark:border-t lg:px-8", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const markup = t3;
  let t4;
  if ($[5] !== animate || $[6] !== markup) {
    t4 = animate ? <BlurFade offset={60} duration={1}>{markup}</BlurFade> : <>{markup}</>;
    $[5] = animate;
    $[6] = markup;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export function SectionContentCard(t0) {
  const $ = _c(8);
  const {
    animate: t1,
    className,
    children
  } = t0;
  const animate = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("w-full rounded-xl border bg-card px-4 pb-8 pt-6 md:p-8", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const markup = t3;
  let t4;
  if ($[5] !== animate || $[6] !== markup) {
    t4 = animate ? <BlurFade offset={60}>{markup}</BlurFade> : <div className="relative">{markup}</div>;
    $[5] = animate;
    $[6] = markup;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
type SectionHeaderProps = {
  label: string;
  title: string;
  subtitle: string;
  animate?: boolean;
};
export function SectionHeader(t0) {
  const $ = _c(13);
  const {
    label,
    title,
    subtitle,
    animate: t1
  } = t0;
  const animate = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== title) {
    t2 = <SectionHeading className="mt-6">{title}</SectionHeading>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const titleMarkup = t2;
  let t3;
  if ($[2] !== subtitle) {
    t3 = <p className="mt-4 max-w-sm text-pretty px-4 md:max-w-xl md:px-0">{subtitle}</p>;
    $[2] = subtitle;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const subtitleMarkup = t3;
  let t4;
  if ($[4] !== label) {
    t4 = <Badge variant="outline">{label}</Badge>;
    $[4] = label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== animate || $[7] !== subtitleMarkup || $[8] !== titleMarkup) {
    t5 = animate ? <><BlurFade delay={0.25}>{titleMarkup}</BlurFade><BlurFade delay={0.5}>{subtitleMarkup}</BlurFade></> : <><>{titleMarkup}</><>{subtitleMarkup}</></>;
    $[6] = animate;
    $[7] = subtitleMarkup;
    $[8] = titleMarkup;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <header className="flex flex-col items-center py-2 text-center">{t4}{t5}</header>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export function SectionHeading(t0) {
  const $ = _c(5);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("mt-2 max-w-md text-pretty text-center text-2xl font-bold tracking-tight md:max-w-none md:text-4xl", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <h2 className={t1}>{children}</h2>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function SectionBody(t0) {
  const $ = _c(5);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("mt-8 rounded-xl", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}

// Recycled

// 01 May 2025

// `scroll-mt-[${SECTION_SCROLL_MARGIN}px]`

// 02 May 2025

// export function Section({ label, title, subtitle, sectionId, className, children }: SectionProps) {
//   return (
//     <SectionBoundary sectionId={sectionId}>
//       <SectionWrapper className={className}>
//         <SectionHeader label={label} title={title} subtitle={subtitle} />

//         <SectionBody>{children}</SectionBody>
//       </SectionWrapper>
//     </SectionBoundary>
//   );
// }